import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header header-elements-inline" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Schauen Sie sich diesen Alarm genauer an")
], -1)
const _hoisted_5 = { class: "media-list media-list-linked media-list-bordered" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "mr-3 position-relative" }
const _hoisted_8 = {
  key: 0,
  class: "icon-exclamation position-absolute right-0 bg-danger text-white rounded-circle"
}
const _hoisted_9 = { class: "media-body" }
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = {
  key: 0,
  class: "text-danger font-size-xs"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", { class: "list-icons-item" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, tabIndex) => {
          return (_openBlock(), _createElementBlock("li", {
            key: tabIndex,
            class: _normalizeClass({'disabled':tab.disabled})
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["media cursor-pointer align-items-center", {'disabled':tab.disabled}]),
              onClick: ($event: any) => (_ctx.showDetails(tab.pathName))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", {
                  class: _normalizeClass(["btn bg-transparent rounded-pill border-2 btn-icon", tab.class])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(tab.icon)
                  }, null, 2)
                ], 2),
                (tab.errors !== null)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(tab.headline) + " ", 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(tab.text), 1),
                (tab.errors !== null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Fehler in dieser Anlage"))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_12
            ], 10, _hoisted_6)
          ], 2))
        }), 128))
      ])
    ])
  ]))
}